import {observer} from "mobx-react-lite"
import React from "react"
import AsyncSelect from "react-select/async"
import EntityCompare from "../store/entities/EntityCompare"
import {selectStyler} from "./SelectStyler";


export interface OzonEntityOption {
    label: string,
    value: string,
}

export const AsyncEntitySelection = observer(({entity}: { entity: EntityCompare }) => {

    return <AsyncSelect<OzonEntityOption>
        placeholder={"Выбрать..."}
        {...selectStyler}
        defaultValue={entity.defaultOption}
        onFocus={() => entity.getDefaultOptions()}
        isClearable
        onChange={(value) => {
            if (value) {
                entity.setAndSave(value.label, value.value)
            } else {
                entity.delete()
            }
        }
        }
        defaultOptions={entity.defaultOptions}
        loadOptions={entity.getOptions}
    />
})

